import { useInvoiceFormContext } from '@/components/Fiscal/Invoice/InvoiceFormProvider';
import { InvoiceType } from '@/core/domain/invoice/invoices/invoices.enums';
import SendEmailInternalButton from './SendEmailInternalButton';

export function InvoiceSendEmailInternal() {
  const {
    isNfe,
    isNfc,
    isNfs,
    isInternalApiIssued,
    useInternalInvoiceApiNfe,
    useInternalInvoiceApiNfc,
    useInternalInvoiceApiNfs,
  } = useInvoiceFormContext();

  if (isNfe && (useInternalInvoiceApiNfe || isInternalApiIssued)) {
    return <SendEmailInternalButton type={InvoiceType.NFE} />;
  }

  if (isNfc && (useInternalInvoiceApiNfc || isInternalApiIssued)) {
    return <SendEmailInternalButton type={InvoiceType.NFC} />;
  }

  if (isNfs && (useInternalInvoiceApiNfs || isInternalApiIssued)) {
    return <SendEmailInternalButton type={InvoiceType.NFS} />;
  }

  return null;
}
